import React from 'react';
import { connect } from 'react-redux';

import { DashboardApp } from '@appblocks/frontend/client/Components/DeviceDashboard/App';
import {
    makeid,
    axiosInstance,
} from '@appblocks/frontend/client/utils';
import {
    CMD_VARIABLE,
    CMD_TABLE,
    CMD_SYSTEM,
    CMD_VARIABLE_ACTION,
    CMD_TABLE_ACTION,
    CMD_SYSTEM_ACTION,
} from '@appblocks/frontend/client/Components/DeviceDashboard/constants';

let counter = 0;
const maxTries = 10;

const mapStateToProps = state => state;

class CloudDeviceDashboard extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            dashboardNotFound: false,
            connected: false,
            deviceStatus: {},
        };

        this.runCommand = this.runCommand.bind(this);
        this.getDevice = this.getDevice.bind(this);
    }

    componentDidMount() {
        this.getDevice();
        if (this.interval) {
            clearInterval(this.interval);
        }
        this.interval = setInterval(this.getDevice, 5000);
    }

    componentWillUnmount() {
        if (this.interval) {
            clearInterval(this.interval);
        }
    }

    async getDevice() {
        try {
            const res = await axiosInstance.get(`${process.env.API_URL}/cgg/devices/${this.props.deviceId}`, {});
            const device = res.data;
            this.setState({
                device,
                deviceStatus: {
                    ...device.state,
                    lastUpdate: new Date().valueOf(),
                },
                connected: device.state.connected,
            });
        } catch (err) {
            this.setState({
                connected: false,
            });
        }
    }

    setDashboardNotFound(dashboardNotFound) {
        this.setState({
            dashboardNotFound,
        });
    }

    runCommand(type, action, data = {}) {
        return new Promise((resolve, reject) => {
            if (this.props.deviceId === undefined) {
                return;
            }
            const api_url_base = `${process.env.API_URL}/cgg/devices/${this.props.deviceId}`;
            const httpConfig = {
                method: 'POST',
                url: `${api_url_base}/api.html`,
                data: {},
            };
            let completionPromise;
            const ApiTypeKey = 'e';
            let ApiTypeValue;
            let ApiActionKey = 'action';
            let ApiActionValue = action;
            let dataOnly = false;
            if (type === CMD_VARIABLE) {
                ApiTypeValue = 'v';
                switch (action) {
                    case CMD_VARIABLE_ACTION.GET:
                        httpConfig.method = 'GET';
                        httpConfig.url = `${api_url_base}/variables/${data.variable}`;
                        break;
                    case CMD_VARIABLE_ACTION.SET:
                        httpConfig.url = `${api_url_base}/variables/${data.variable}`;
                        completionPromise = new Promise((_resolve) => {
                            counter = 0;
                            const changePollInterval = setInterval(() => {
                                if (counter >= maxTries
                                    || !this.state.connected) {
                                    clearInterval(changePollInterval);
                                    this.getDevice();
                                    _resolve();
                                }

                                axiosInstance({
                                    method: 'GET',
                                    url: `${api_url_base}/variables/${data.variable}/changes`,
                                }).then((res) => {
                                    const response = res.data;
                                    if (response.length === 0) {
                                        clearInterval(changePollInterval);
                                        _resolve(response);
                                    }
                                }).catch((err) => {
                                    clearInterval(changePollInterval);
                                    reject(err);
                                });
                                counter++;
                            }, 1000);
                        });
                        break;
                    case CMD_VARIABLE_ACTION.CANCEL_CHANGES:
                        httpConfig.url = `${api_url_base}/variables/changes`;
                        httpConfig.method = 'DELETE';
                        completionPromise = new Promise((_resolve) => {
                            this.getDevice();
                            _resolve();
                        });
                        break;
                    case CMD_VARIABLE_ACTION.GET_WIDGET_VARIABLES:
                        httpConfig.url = `${api_url_base}/variables`;
                        ApiActionKey = 'a';
                        httpConfig.method = 'GET';
                        ApiTypeValue = 'w';
                        ApiActionValue = 'get';
                        break;
                    default:
                        break;
                }
            } else if (type === CMD_TABLE) {
                ApiTypeValue = 't';
                ApiActionKey = 'a';
                switch (action) {
                    case CMD_TABLE_ACTION.ROWS:
                        httpConfig.url = `${api_url_base}/tables/${data.table}`;
                        httpConfig.method = 'GET';
                        break;
                    case CMD_TABLE_ACTION.COUNT:
                        httpConfig.url = `${api_url_base}/tables/${data.table}/count`;
                        httpConfig.method = 'GET';
                        dataOnly = true;
                        break;
                    case CMD_TABLE_ACTION.ADD:
                        httpConfig.url = `${api_url_base}/tables/${data.table}/changes`;
                        data = {
                            action: 'add',
                            row: undefined,
                            data: data.row,
                            table: data.table,
                        };
                        dataOnly = true;
                        break;
                    case CMD_TABLE_ACTION.DELETE:
                        httpConfig.url = `${api_url_base}/tables/${data.table}/changes`;
                        data = {
                            action: 'remove',
                            row: data.row,
                            data: undefined,
                            table: data.table,
                        };
                        dataOnly = true;
                        break;
                    case CMD_TABLE_ACTION.EDIT:
                        httpConfig.url = `${api_url_base}/tables/${data.table}/changes`;
                        data = {
                            action: 'update',
                            row: data.index,
                            data: data.row,
                            table: data.table,
                        };
                        dataOnly = true;
                        break;
                    case CMD_TABLE_ACTION.CLEAR:
                        httpConfig.url = `${api_url_base}/tables/${data.table}/changes`;
                        data = {
                            action: 'clear',
                            table: data.table,
                        };
                        dataOnly = true;
                        break;
                    case CMD_TABLE_ACTION.CANCEL_CHANGES:
                        httpConfig.url = `${api_url_base}/tables/changes`;
                        httpConfig.method = 'DELETE';
                        completionPromise = new Promise((_resolve) => {
                            this.getDevice();
                            _resolve();
                        });
                        break;
                    case CMD_TABLE_ACTION.IMPORT:
                        httpConfig.url = `${api_url_base}/tables/${data.table}/changes`;
                        data = {
                            action: 'import',
                            data: data.contents,
                            table: data.table,
                        };
                        dataOnly = true;
                        break;
                    default:
                        break;
                }
                if (action !== CMD_TABLE_ACTION.ROWS) {
                    completionPromise = new Promise((_resolve) => {
                        counter = 0;
                        const changePollInterval = setInterval(() => {
                            if (counter >= maxTries
                                || !this.state.connected) {
                                clearInterval(changePollInterval);
                                this.getDevice();
                                _resolve();
                            }

                            axiosInstance({
                                method: 'GET',
                                url: `${api_url_base}/tables/${data.table}/changes`,
                            }).then((res) => {
                                const response = res.data;
                                if (response.length === 0) {
                                    clearInterval(changePollInterval);
                                    _resolve(response);
                                }
                            }).catch((err) => {
                                clearInterval(changePollInterval);
                                reject(err);
                            });
                            counter++;
                        }, 1000);
                    });
                }
            } else if (type === CMD_SYSTEM) {
                ApiTypeValue = 'i';
                switch (action) {
                    case CMD_SYSTEM_ACTION.GET_AUTH:
                        return resolve('0');
                    case CMD_SYSTEM_ACTION.INFORMATION_GET:
                        httpConfig.url = `${api_url_base}`;
                        httpConfig.method = 'GET';
                        ApiActionValue = 'get';
                        break;
                    case CMD_SYSTEM_ACTION.UPDATE_TIME:
                        httpConfig.url = `${api_url_base}`;
                        ApiActionValue = 'edit_t';
                        break;
                    case CMD_SYSTEM_ACTION.GET_TIMEZONE:
                        httpConfig.url = `${api_url_base}`;
                        httpConfig.method = 'GET';
                        ApiActionValue = 'get_tz';
                        break;
                    case CMD_SYSTEM_ACTION.UPDATE_TIMEZONE:
                        httpConfig.url = `${api_url_base}`;
                        ApiActionValue = 'edit_tz';
                        break;
                    case CMD_SYSTEM_ACTION.GET_DASHBOARD_SETUP:
                        httpConfig.url = `${api_url_base}/config`;
                        httpConfig.method = 'GET';
                        dataOnly = true;
                        break;
                    // case CMD_SYSTEM_ACTION.GET_FIRMWARE_UPLOAD_PROGRESS:
                    //     httpConfig.method = 'GET';
                    //     dataOnly = true;
                    //     break;
                    // case CMD_SYSTEM_ACTION.POST_FIRMWARE_UPLOAD:
                    //     dataOnly = true;
                    //     break;
                    case CMD_SYSTEM_ACTION.LOGIN:
                        ApiTypeValue = 'a';
                        ApiActionValue = 'login';
                        break;
                    case CMD_SYSTEM_ACTION.RUN_COMMAND:
                        httpConfig.url = `${api_url_base}/commands/${data.variable}`;
                        ApiTypeValue = 'f';
                        dataOnly = true;
                        data = {
                            data: data.value || '',
                        };
                        break;
                    case CMD_SYSTEM_ACTION.SEND_COMMAND:
                        httpConfig.url = `${api_url_base}/system/${data.cmd}`;
                        break;
                    // case CMD_SYSTEM_ACTION.SAVE_UNOWIRE_SENSOR:
                    //     dataOnly = true;
                    //     break;
                    // case CMD_SYSTEM_ACTION.SCAN_UNOWIRE_SENSORS:
                    // case CMD_SYSTEM_ACTION.GET_UNOWIRE_SENSORS:
                    //     httpConfig.method = 'GET';
                    //     dataOnly = true;
                    //     break;
                    default:
                        break;
                }
            } else {
                resolve('');
            }
            httpConfig.data = {
                ...data,
            };
            if (!dataOnly) {
                httpConfig.data = {
                    [ApiTypeKey]: ApiTypeValue,
                    [ApiActionKey]: ApiActionValue,
                    ...data,
                };
            }

            axiosInstance(httpConfig).then(async (res) => {
                let response = res.data;
                if (ApiTypeValue === 'w') {
                    response = {};
                    Object.keys(res.data).forEach((key) => {
                        response[key] = res.data[key].value;
                    });
                }
                if (ApiTypeValue === 'v' && ApiActionValue === 'get') {
                    response = res.data.value;
                }
                if (completionPromise !== undefined) {
                    await completionPromise;
                }
                if (action === CMD_SYSTEM_ACTION.INFORMATION_GET) {
                    response = res.data.state;
                }
                resolve(response);
            }).catch((err) => {
                reject(err);
            });
        });
    }

    render() {
        if (this.props.deviceId === undefined) {
            return (
                <></>
            );
        }
        if (this.state.dashboardNotFound) {
            return (
                <div className="container">
                    <h1>Dashboard not found</h1>
                </div>
            );
        }

        return (
            <DashboardApp
                runCommand={this.runCommand}
                memoryRouter
                setSessionPassword={this.setSessionPassword}
                connected={this.state.connected}
                deviceStatus={this.state.deviceStatus}
                getDeviceState={this.getDevice}
                systemPage={false}
                device={this.state.device}
            />
        );
    }
}

export default connect(mapStateToProps, {})(CloudDeviceDashboard);
